import React from "react";
import { newContextComponents } from "@drizzle/react-components";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class Price extends React.Component {
  state = { dataKey: null };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;
  
    // let drizzle know we want to watch the `myString` method
    const dataKey = contract.methods[this.props.priceName].cacheCall();
  
    // save the `dataKey` to local component state for later reference
    this.setState({ dataKey });
  }
  

  // destructure drizzle and drizzleState from props
  render() {
    // get the contract state from drizzleState
    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    // using the saved `dataKey`, get the variable we're interested in
    const priceFromContract = GAMEFORESTSale[this.props.priceName][this.state.dataKey];
    
    if(priceFromContract !== undefined) {
      const reversePrice = 1.0/priceFromContract.value;
      return <div>{reversePrice+" BNB/GF"}</div>;
    }
    
    return '--';
  }
};

export default Price;